export default __webpack_public_path__ + "static/media/image.beb436e0.png";